/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

/*@ngInject*/
export default function IntegrationDlStatisticsController($mdDialog, integrationService, entityId) {
    var vm = this;
    vm.rows = [];
    vm.loading = true;
    vm.cancel = cancel;

    integrationService.getDlStatistics(entityId).then(
        (data) => {
            vm.rows = data;
            vm.loading = false;
        },
        () => {
            vm.loading = false;
        }
    );

    function cancel() {
        $mdDialog.cancel();
    }
}



// WEBPACK FOOTER //
// ./src/app/integration/integration-dl-statistics.controller.js